(function($) {
    'use strict';

    $('.category-bar__trigger').on('click', function() {
        window.groots.methods.toggleAttributeValue($(this).parent()[0], 'gr-category-bar', 'active');
    });

})(jQuery);
